/**
 * The API this build talks to.
 *
 * The default is production, and the override lives in .env.local, which is
 * gitignored. This file used to hold the URL directly, which meant every
 * developer's copy differed from the committed one - so a broad `git add`
 * could put a local host onto master, and a build from that would send every
 * request in production to a machine that does not exist. Same reason the
 * Turnstile sitekey is read from the environment rather than stored here.
 *
 * To point a local build somewhere else, create .env.local:
 *   VUE_APP_API_URL=http://amf-api.test/api
 */
export const API_URL = process.env.VUE_APP_API_URL || 'https://api.allmyfaves.com/api';
export default API_URL;
